import React from "react";
import { Stack, Tooltip, Typography } from "investira.react.components";
import { formats } from "investira.sdk";

const PrecisionNumberDisplay = ({
  value,
  threshold = 0.0001,
  placement = "top",
  sufix = null,
  showCurrency = false,
}) => {
  // Verifica se o valor é um número válido
  const numberValue = parseFloat(value);
  const isInvalidNumber = isNaN(numberValue);
  // Calcula o decimal a ser usado
  const decimal = getDecimalFromThreshold(threshold);

  function calcDecimal(pValue, pMinSigDigitos = 4) {
    const xMatch = pValue.toString().match(/e-(\d+)/);
    const xExpoente = xMatch ? parseInt(xMatch[1], 10) : 0;

    // Calcula as casas decimais necessárias (expoente + dígitos significativos - 1)
    const xDecimal = xExpoente + pMinSigDigitos;
    return xDecimal;
  }

  // Função para calcular o número de casas decimais necessárias para exibir valores menores que o threshold
  function getDecimalFromThreshold(threshold) {
    if (typeof threshold !== "number" || threshold <= 0) return 4;
    // Conta o número de zeros após o ponto decimal até o primeiro dígito significativo
    const thresholdStr = threshold.toString();
    const match = thresholdStr.match(/(?:\.(0*))[1-9]/);
    if (match && match[1]) {
      return match[1].length + 1;
    }
    // Se não encontrar zeros, retorna 4 como padrão
    return 4;
  }

  // Função para formatar o valor completo
  const formatFullValue = (num) => {
    if (isInvalidNumber) return String(value);

    return new Intl.NumberFormat("pt-BR", {
      maximumFractionDigits: 20,
      useGrouping: false,
    }).format(num);
  };

  // Função para determinar o display value
  const getDisplayValue = () => {
    if (isInvalidNumber) return String(value);

    const absValue = Math.abs(numberValue);

    // Verifica se precisa de formatação especial
    if (absValue > 0 && absValue < threshold) {
      return formats.formatNumber(
        value,
        calcDecimal(value, decimal),
        true,
        false
      );
    }

    // Formatação padrão para números dentro do threshold
    return numberValue.toString();
  };

  // Renderização condicional
  const displayValue = getDisplayValue();
  const absValue = Math.abs(numberValue);
  const needsTooltip = !isInvalidNumber && absValue > 0 && absValue < threshold;

  return (
    <Tooltip
      title={formatFullValue(numberValue)}
      placement={placement}
      arrow
      disableHoverListener={!needsTooltip}
    >
      <Stack direction="row" justifyContent="flex-end">
        <Typography
          component="span"
          sx={{
            display: "inline",
            cursor: needsTooltip ? "help" : "default",
            textDecoration: needsTooltip ? "underline dotted" : "none",
            fontSize: "inherit",
            whiteSpace: "nowrap",
          }}
        >
          {absValue < threshold
            ? `>${threshold.toString().replace(".", ",")}`
            : formats.formatNumber(displayValue, decimal, true, showCurrency)}
          {sufix}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default PrecisionNumberDisplay;
